
export const Style = {
        backgroundColor: '#3B4CCA'
    }
export const TitleStyle = {
        display: 'flex',
        justifyContent: 'center'
    }
export const ImageStyle = {
    height: '100px'
}
export const NavStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px'
}
export const LinkStyle = {
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:active': {
        textDecoration: 'underline',
    }
}